import NotificationSkeleton from './NotificationSkeleton';

export default NotificationSkeleton;
